import React from "react";
import cakeImg from "../../Assets/landingPage/frond_ventures_diverse_startup.webp";
import planImg from "../../Assets/landingPage/frond_events_wedding.webp";
import stayImg from "../../Assets/landingPage/frond_home_kitchen_remodel.webp";
import makeImg from "../../Assets/landingPage/frond_home_renovation.webp";

const Dreams = () => {
  return (
    <section className="dreams py-12">
      <div className="container xl:px-20 px-6 mx-auto">
        <div className="rounded-4xl border-2 border-solid border-cardColor overflow-hidden shadow-mainShadow">
          <div className="grid lg:grid-cols-2">
            {/* Left Side - Image and FEATURED Section */}
            <div className="left-side p-8 md:p-10">
              {/* Top Image */}
              <div className="mb-8">
                <img
                  src={cakeImg}
                  alt="Dreams"
                  className="w-full h-80 object-cover rounded-lg"
                />
              </div>
              
              {/* FEATURED Section */}
              <div className="featured-section  bg-gray-50 p-6 md:p-4 rounded-lg">
                <div className="mb-2">
                  <span className="text-gray-400 text-sm uppercase tracking-wide font-semibold">
                    FEATURED
                  </span>
                </div>
                
                <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900">
                  Turn your dreams into reality with your all-in-one personal
                  project management app
                </h2>
                
                <div className="mt-2">
                  <span className="text-gray-500 text-sm uppercase tracking-wide">
                    PROJECT MANAGEMENT
                  </span>
                </div>
              </div>
            </div>
            
            {/* Right Side - 3 Features */}
            <div className="right-side bg-gray-50 p-6 md:p-4 flex flex-col justify-center">
              <div className="space-y-8">
                {/* Feature 1 */}
                <div className="flex gap-2 items-start">
                  <div className="w-48 h-32 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={planImg}
                      alt="Plan"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <p className="text-textColor leading-relaxed">
                      <strong className="font-bold">Plan anything:</strong> From
                      epic vacations to home renovations or dream weddings and
                      honeymoons, frond keeps your ideas organized and in the same
                      place.
                    </p>
                  </div>
                </div>
                
                {/* Feature 2 */}
                <div className="flex gap-2 items-start">
                  <div className="w-48 h-32 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={stayImg}
                      alt="Stay on track"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <p className="text-textColor leading-relaxed">
                      <strong className="font-bold">Stay on track:</strong> Manage
                      timelines, budgets, and collaborate seamlessly with others. Share
                      your project with friends and family to keep everyone in the loop.
                    </p>
                  </div>
                </div>
                
                {/* Feature 3 */}
                <div className="flex gap-2 items-start">
                  <div className="w-48 h-32 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={makeImg}
                      alt="Make it happen"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <p className="text-textColor leading-relaxed">
                      <strong className="font-bold">Make it happen:</strong> Frond
                      empowers you to transform your plans from ideas into reality.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dreams;